export enum LocationType {
  COMPANY = 'COMPANY',
  STRUCTURE = 'STRUCTURE',
  SITE = 'SITE',
}
